<template>
  <div style="height: inherit">
    <!-- <v-img
      class="bgImage mt-n1"
      :src="$store.state.EventBranding[0].eventBGImage"
    /> -->
    <div
      class="gridBorder"
      :class="$vuetify.breakpoint.smAndDown ? 'pb-5' : ''"
    >
      <v-row class="mt-0 mx-5" no-gutters>
        <!-- <v-col  v-if="!$vuetify.breakpoint.xs" class="ml-4 font-weight-bold text-lg-h5 float-left">
          <span v-if="isAssignmentsRoute && !$vuetify.breakpoint.xs">Assignments</span>
        </v-col> -->
        <v-col
          v-if="!$vuetify.breakpoint.smAndDown"
          class="pt-3"
          cols="4"
          md="4"
          ><span
            style="position: relative"
            class="page-head text-uppercase pa-3 mt-2"
            >Assignments</span
          ></v-col
        >
        <v-col cols="12" sm="12" md="4">
          <v-row justify="center" align="center" no-gutters class="mt-3 mb-3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-hover v-slot="{ hover }">
                  <v-btn
                    v-if="selectedSession ? selectedSession.isHost : false"
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    outlined
                    @click="setState('tab4')"
                    elevation="0"
                    retain-focus-on-click
                    :style="
                      hover || tabClick.tab4
                        ? 'background-color:black !important;color:white'
                        : 'background-color:#E3F2FD !important;color:grey'
                    "
                    >Created</v-btn
                  >
                </v-hover>
              </template>
              <span>Filters only created assignments </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-hover class="" v-slot="{ hover }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ml-3"
                    outlined
                    rounded
                    @click="setState('tab1')"
                    elevation="0"
                    retain-focus-on-click
                    :style="
                      hover || tabClick.tab1
                        ? 'background-color:black !important;color:white'
                        : 'background-color:#E3F2FD !important;color:grey'
                    "
                    >Issued</v-btn
                  >
                </v-hover>
              </template>
              <span>Filters only issued assignments </span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-hover v-slot="{ hover }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    outlined
                    class="mr-3 ml-3"
                    @click="setState('tab2')"
                    elevation="0"
                    retain-focus-on-click
                    :style="
                      hover || tabClick.tab2
                        ? 'background-color:black !important;color:white'
                        : 'background-color:#E3F2FD !important;color:grey'
                    "
                    >Submitted</v-btn
                  >
                </v-hover>
              </template>
              <span>Filters only submitted assignments </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-hover v-slot="{ hover }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    outlined
                    @click="setState('tab3')"
                    elevation="0"
                    retain-focus-on-click
                    :style="
                      hover || tabClick.tab3
                        ? 'background-color:black !important;color:white'
                        : 'background-color:#E3F2FD !important;color:grey'
                    "
                    >Assessed</v-btn
                  >
                </v-hover>
              </template>
              <span>Filters only assessed assignments </span>
            </v-tooltip>
          </v-row>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-row justify="center" align="center" class="mt-0">
            <v-spacer
              v-if="selectedSession ? !selectedSession.isHost : true"
            ></v-spacer>
            <v-col
              cols="7"
              class="ml-2 pb-0"
              :class="
                selectedSession
                  ? selectedSession.isHost
                  : true
                  ? ''
                  : 'mr-4 pl-0'
              "
            >
              <v-autocomplete
                class="checkScroller"
                :items="items"
                prepend-inner-icon="search"
                :disabled="contentLoadedAuto"
                :loading="contentLoadedAuto"
                return-object
                hide-details
                :item-text="createdSessionName"
                v-model="selectedSession"
                clearable
                label="Search Session"
                dense
                outlined
              >
              </v-autocomplete>
            </v-col>

            <v-col
              v-if="selectedSession ? selectedSession.isHost : false"
              class="pb-0 mr-3"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-2"
                    v-bind="attrs"
                    block
                    v-on="on"
                    @click="openCreateAssignment()"
                    color="primary"
                    >create</v-btn
                  >
                </template>
                <span>Creates new assignment</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-3 px-2" no-gutters>
        <v-card
          style="width: 100%; font-size: 16px"
          class="ma-5"
          v-if="AssignmentsList.length > 0"
        >
          <v-data-table
            class="assignment"
            loading-text="Please wait, Assignments are loading."
            :headers="headers"
            :items-per-page="10"
            :sort-by="['creationDate']"
            :sort-desc="[true]"
            :items="AssignmentsList"
          >
            <template #item.FirstName="{ item }">
              <span>{{ item.FirstName }}</span>
            </template>
            <template #item.creationDate="{ item }">
              <span>{{ getFormatted(new Date(item.creationDate)) }}</span>
            </template>
            <template #item.uploadDate="{ item }">
              <span>{{
                item.uploadDate ? getFormatted(new Date(item.uploadDate)) : "NA"
              }}</span>
            </template>
            <template #item.status="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      openAssignment(item, item.status ? item.status : 'Issued')
                    "
                    style="cursor: pointer"
                    outlined
                    :color="
                      item.status
                        ? item.status == 'Submitted'
                          ? 'success'
                          : 'primary'
                        : '#e5ac27'
                    "
                    :text-color="
                      item.status
                        ? item.status == 'Submitted'
                          ? 'success'
                          : 'primary'
                        : '#e5ac27'
                    "
                  >
                    <v-icon
                      v-if="
                        item.status == 'Submitted' || item.status == 'Assessed'
                      "
                    >
                      check
                    </v-icon>
                    <span
                      >{{
                        item.status
                          ? item.status
                          : item.FirstName == "Created"
                          ? "Created"
                          : "Issued"
                      }}
                    </span>
                  </v-chip>
                </template>
                <span
                  >{{
                    item.status
                      ? item.status
                      : item.FirstName == "Created"
                      ? "Created"
                      : "Issued"
                  }}
                </span>
              </v-tooltip>
            </template>

            <template #item.blindCheck="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="font-weight-bold"
                    @click="openAssignment(item, 'Assignment row action')"
                    style="cursor: pointer"
                  >
                    {{ ". . ." }}
                  </span>
                </template>
                <span> Open assignment details</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-row>
    </div>
    <v-col style="height: 70vh !important" v-if="contentLoaded">
      <v-row class="fill-height" align="center" justify="center">
        <v-progress-circular
          size="80"
          indeterminate
          color="primary"
        ></v-progress-circular
      ></v-row>
    </v-col>
    <v-col
      style="height: 70vh !important"
      v-if="AssignmentsList.length == 0"
    >
      <v-row class="fill-height" align="center" justify="center">
        <div class="no-assignment-data">
          <v-icon color="#8a8a8a" size="80px">mdi-clipboard-text</v-icon>
          <p>{{ "No Assignments found" }}</p>
        </div>
      </v-row>
    </v-col>
    <!-- <v-row
      class="fill-height mt-8"
      align="center"
      justify="center"
      v-if="AssignmentsList.length == 0 && !contentLoaded"
      >No Assignments found</v-row
    > -->
    <v-navigation-drawer
      class="right-sidebar"
      style="position: fixed"
      :width="$vuetify.breakpoint.xs ? '100%' : '50%'"
      right
      v-model="drawer"
      absolute
      temporary
    >
      <v-container class="px-6">
        <v-row justify="end" align="end">
          <div class="pt-2">
            <v-img
              style="cursor: pointer"
              @click="(drawer = false), closeDrawer(currentAssignment)"
              src="../../assets/e2medu/icons/close-24px.svg"
            ></v-img>
          </div>
        </v-row>
        <v-row
          v-if="isHost && currentAssignment.FirstName == 'Created'"
          class="font-weight-bold text-lg-h4 mt-2 ml-2"
          >Bulk Task Assignment</v-row
        >
        <v-col class="ma-2">
          <v-row class="font-weight-bold text-md-h6 mt-2 mb-5">
            {{ currentAssignment.sessionName }} -
            {{ currentAssignment.Name }}
          </v-row>
          <v-row v-if="false">
            <v-avatar color="#626262" size="40"
              ><span style="color: white">{{
                getInitials($store.state.user.Name)
              }}</span>
            </v-avatar>
            <div class="ml-3">
              <div class="font-weight-medium text-lg">Student Name</div>
              <div>Grade 3, ABC High School</div>
            </div>

            <v-chip
              class="ml-11 mt-2"
              v-if="isHost && (currentAssignment.isPublished || ispublishDone)"
              color="green"
            >
              Published
              <v-icon dark right green> mdi-checkbox-marked-circle </v-icon>
            </v-chip>
          </v-row>
          <v-row v-if="isHost && currentAssignment.FirstName == 'Created'">
            <v-col class="ml-10">
              <span style="font-size: larger">
                Select the students you want to assign the assignment to
                <v-checkbox
                  style="margin-bottom: 0"
                  hide-details
                  @click="selectAllClicked"
                  v-model="selectAll"
                  v-if="!selectAllDisable"
                  label="Select All"
                ></v-checkbox>
                <div
                  v-for="(attendee, index) in selectedSession.IncludedAttendees"
                  :key="index"
                >
                  <v-checkbox
                    style="margin-bottom: 0"
                    v-if="!checkBoxDisabled(attendee)"
                    hide-details
                    v-model="checkBoxVal"
                    :value="attendee"
                    :label="attendee.Name"
                  ></v-checkbox>
                  <v-checkbox
                    class="unchecked-fields"
                    style="margin-bottom: 0"
                    v-else
                    v-model="disabledCheckBox"
                    hide-details
                    disabled
                    value="disabled"
                    :label="attendee.Name"
                  ></v-checkbox>
                </div>
              </span>
              <div class="mt-3 mb-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      @click="publish()"
                      :disabled="checkBoxVal.length == 0"
                      block
                      :loading="contentLoadedSmall"
                      color="success"
                    >
                      Issue
                    </v-btn>
                  </template>
                  <span>Issue this Assignment</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col>
              <v-row class="pt-1" no-gutters>
                <v-col
                  v-if="isHost && !currentAssignment.isPublished"
                  class=""
                  style="display: flex; flex-direction: row-reverse"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        :loading="deleteButtonLoader"
                        color="error"
                        @click="deleteAssignment()"
                      >
                        Delete
                      </v-btn>
                    </template>
                    <span>Delete this Assignment</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-col
            v-if="
              currentAssignment.isPublished ||
              ispublishDone ||
              currentAssignment.FirstName == 'Created'
            "
          >
            <v-card
              v-if="false"
              elevation="4"
              style="min-height: 300px; max-width: 94%; left: 30px; top: 30px"
            >
              <v-col>
                <v-row
                  :justify="
                    msg.uploaderId == $store.state.user.UserId ? 'end' : ''
                  "
                  v-for="(msg, index) in messageList"
                  v-bind:key="index"
                >
                  <v-chip
                    :color="
                      msg.uploaderId == $store.state.user.UserId
                        ? '#C0EFF6'
                        : '#cccccc'
                    "
                    class="ma-2"
                  >
                    <span class="font-weight-bold">
                      {{ msg.attendeeName }} :
                    </span>
                    <span class="ml-1"> {{ msg.message }}</span>
                  </v-chip>
                </v-row>
              </v-col>
            </v-card>
            <v-row v-if="false" class="ml-10 mr-1 mt-10">
              <v-textarea rows="1" v-model="message" outlined label="Compose">
              </v-textarea>
            </v-row>
            <v-timeline dense>
              <v-timeline-item color="#e5ac27" small>
                <div>
                  <v-row class="px-0">
                    <v-col cols="4" class="mt-7 px-0">
                      <strong style="font-size: large" class="">{{
                        currentAssignment.FirstName == "Created"
                          ? getTimeLineDate(currentAssignment.creationDate)
                          : getTimeLineDate(currentAssignment.publishDate)
                      }}</strong>
                    </v-col>
                    <v-col class="mt-2">
                      <div>
                        <v-row
                          style="font-size: large"
                          class="font-weight-bold text-lg pb-2 mt-3 pt-2"
                        >
                          Assignment Uploaded
                          <div class="mt-n2">
                            <v-btn
                              @click.stop="
                                createdAdditionalAdd = !createdAdditionalAdd
                              "
                              v-if="tabClick.tab4"
                              icon
                              ><v-icon v-if="!createdAdditionalAdd"
                                >attach_file</v-icon
                              >
                              <v-icon v-else>close</v-icon>
                            </v-btn>
                          </div>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="display: inline-flex"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            downloadAttachments(
                              currentAssignment.signedUrl[0],
                              currentAssignment.fileName
                            )
                          "
                        >
                          <v-img
                            max-width="30px"
                            max-height="30px"
                            style="cursor: pointer"
                            src="../../assets/e2medu/file.png"
                          >
                          </v-img>
                          <span style="cursor: pointer" class="mt-2 pl-1">
                            {{ compressName(currentAssignment.fileName) }}
                          </span>
                          <v-icon style="cursor: pointer; padding-top: 6px"
                            >file_download</v-icon
                          >
                        </div>
                      </template>
                      <span>
                        Click here to download
                        {{ currentAssignment.fileName }}</span
                      >
                    </v-tooltip>
                  </v-row>
                  <div
                    class="mt-2"
                    v-if="
                      currentAssignment.otherCreatedFiles &&
                      currentAssignment.otherCreatedFiles.length > 0
                    "
                  >
                    <v-row
                      v-for="(data, pos) in currentAssignment.otherCreatedFiles"
                      :class="pos == 0 ? 'pt-3' : 'pt-2'"
                      :key="pos"
                    >
                      <!-- <span>{{data.fileName}}</span> -->

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            style="display: inline-flex"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="
                              downloadAttachments(
                                data.signedUrl[0],
                                data.fileName
                              )
                            "
                          >
                            <v-img
                              max-width="30px"
                              max-height="30px"
                              style="cursor: pointer"
                              src="../../assets/e2medu/file.png"
                            >
                            </v-img>
                            <span style="cursor: pointer" class="mt-2 pl-1">
                              {{ compressName(data.fileName) }}
                            </span>
                            <v-icon style="cursor: pointer; padding-top: 6px"
                              >file_download</v-icon
                            >
                          </div>
                        </template>
                        <span>
                          Click here to download
                          {{ data.fileName }}</span
                        >
                      </v-tooltip>
                    </v-row>
                  </div>
                  <v-row
                    class="pt-2"
                    v-if="tabClick.tab4 && createdAdditionalAdd"
                    no-gutters
                  >
                    <v-col cols="9">
                      <v-file-input
                        v-model="additonalIssuedFile"
                        :accept="acceptedFileFormats"
                        label="Select File"
                        chips
                        hide-details=""
                      ></v-file-input>
                    </v-col>
                    <v-col
                      class="pl-2"
                      cols="3"
                      style="position: absolute; bottom: 0; right: 0"
                    >
                      <v-btn
                        :disabled="!additonalIssuedFile"
                        :loading="otherCreatedLoader"
                        @click="addAdditionaCreatedFiles()"
                        >Add</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-timeline-item>
              <v-timeline-item
                color="success"
                small
                v-if="currentAssignment.submittedFileName"
              >
                <div>
                  <v-row>
                    <v-col cols="4" class="mt-7 px-0">
                      <strong style="font-size: large" class="">{{
                        getTimeLineDate(currentAssignment.uploadDate)
                      }}</strong>
                    </v-col>
                    <v-col class="mt-2">
                      <v-row
                        style="font-size: large"
                        class="pb-2 mt-3 pt-2 font-weight-bold text-lg"
                      >
                        Submitted
                        <div class="mt-n2">
                          <v-btn
                            @click.stop="
                              submittedAdditionalAdd = !submittedAdditionalAdd
                            "
                            v-if="tabClick.tab2 && !isHost"
                            icon
                            ><v-icon v-if="!submittedAdditionalAdd"
                              >attach_file</v-icon
                            >
                            <v-icon v-else>close</v-icon>
                          </v-btn>
                        </div>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="display: inline-flex"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            downloadAttachments(
                              currentAssignment.submittedSignedUrl[0],
                              currentAssignment.submittedFileName
                            )
                          "
                        >
                          <v-img
                            max-width="30px"
                            max-height="30px"
                            style="cursor: pointer"
                            src="../../assets/e2medu/file.png"
                          >
                          </v-img>
                          <span style="cursor: pointer" class="ml-1 mt-2">
                            {{
                              compressName(currentAssignment.submittedFileName)
                            }}
                            <v-icon style="cursor: pointer; padding-top: 6px"
                              >file_download</v-icon
                            >
                          </span>
                        </div>
                      </template>
                      <span
                        ><span>
                          Click here to download
                          {{ currentAssignment.submittedFileName }}</span
                        ></span
                      >
                    </v-tooltip>
                  </v-row>
                  <v-row
                    v-for="(data, pos) in currentAssignment.otherSubmittedFiles"
                    :key="pos"
                  >
                    <!-- <span>{{data.fileName}}</span> -->

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="display: inline-flex"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            downloadAttachments(
                              data.signedUrl[0],
                              data.fileName
                            )
                          "
                        >
                          <v-img
                            max-width="30px"
                            max-height="30px"
                            style="cursor: pointer"
                            src="../../assets/e2medu/file.png"
                          >
                          </v-img>
                          <span style="cursor: pointer" class="mt-2 pl-1">
                            {{ compressName(data.fileName) }}
                          </span>
                          <v-icon style="cursor: pointer; padding-top: 6px"
                            >file_download</v-icon
                          >
                        </div>
                      </template>
                      <span>
                        Click here to download
                        {{ data.fileName }}</span
                      >
                    </v-tooltip>
                  </v-row>
                  <v-row
                    class="pt-2"
                    v-if="tabClick.tab2 && submittedAdditionalAdd"
                    no-gutters
                  >
                    <v-col cols="9">
                      <v-file-input
                        v-model="additonalSubmittedFile"
                        :accept="acceptedFileFormats"
                        label="Select File"
                        chips
                        hide-details=""
                      ></v-file-input>
                    </v-col>
                    <v-col
                      class="pl-2"
                      cols="3"
                      style="position: absolute; bottom: 0; right: 0"
                    >
                      <v-btn
                        :disabled="!additonalSubmittedFile"
                        @click="addAdditionalSubmittedFiles()"
                        :loading="otherSubmittedLoader"
                        >Add</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-timeline-item>
              <v-timeline-item
                color="primary"
                small
                v-if="currentAssignment.assessedFileName"
              >
                <div>
                  <v-row>
                    <v-col cols="4" class="mt-7 px-0">
                      <strong style="font-size: large" class="">{{
                        getTimeLineDate(currentAssignment.assessDate)
                      }}</strong>
                    </v-col>
                    <v-col class="mt-2">
                      <v-row
                        style="font-size: large"
                        class="pt-2 pb-2 mt-3 font-weight-bold text-lg"
                      >
                        Assessed
                        <div class="mt-n2">
                          <v-btn
                            @click.stop="
                              assessedAdditionalAdd = !assessedAdditionalAdd
                            "
                            v-if="tabClick.tab3 && isHost"
                            icon
                            ><v-icon v-if="!assessedAdditionalAdd"
                              >attach_file</v-icon
                            >
                            <v-icon v-else>close</v-icon>
                          </v-btn>
                        </div>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="display: inline-flex"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            downloadAttachments(
                              currentAssignment.assessedSignedUrl[0],
                              currentAssignment.assessedFileName
                            )
                          "
                        >
                          <v-img
                            max-width="30px"
                            max-height="30px"
                            style="cursor: pointer"
                            src="../../assets/e2medu/file.png"
                          >
                          </v-img>
                          <span style="cursor: pointer" class="ml-1 mt-2">
                            {{
                              compressName(currentAssignment.assessedFileName)
                            }}
                            <v-icon style="cursor: pointer; padding-top: 6px"
                              >file_download</v-icon
                            >
                          </span>
                        </div>
                      </template>
                      <span
                        >Click here to download
                        {{ currentAssignment.assessedFileName }}</span
                      >
                    </v-tooltip>
                  </v-row>
                  <v-row
                    v-for="(data, pos) in currentAssignment.otherAssessedFiles"
                    :key="pos"
                  >
                    <!-- <span>{{data.fileName}}</span> -->

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="display: inline-flex"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            downloadAttachments(
                              data.signedUrl[0],
                              data.fileName
                            )
                          "
                        >
                          <v-img
                            max-width="30px"
                            max-height="30px"
                            style="cursor: pointer"
                            src="../../assets/e2medu/file.png"
                          >
                          </v-img>
                          <span style="cursor: pointer" class="mt-2 pl-1">
                            {{ compressName(data.fileName) }}
                          </span>
                          <v-icon style="cursor: pointer; padding-top: 6px"
                            >file_download</v-icon
                          >
                        </div>
                      </template>
                      <span>
                        Click here to download
                        {{ data.fileName }}</span
                      >
                    </v-tooltip>
                  </v-row>
                  <v-row
                    class="pt-2"
                    v-if="tabClick.tab3 && assessedAdditionalAdd"
                    no-gutters
                  >
                    <v-col cols="9">
                      <v-file-input
                        v-model="additonalAssessedFile"
                        :accept="acceptedFileFormats"
                        label="Select File"
                        chips
                        hide-details=""
                      ></v-file-input>
                    </v-col>
                    <v-col
                      class="pl-2"
                      cols="3"
                      style="position: absolute; bottom: 0; right: 0"
                    >
                      <v-btn
                        @click="addAdditionalAssessedFiles()"
                        :disabled="!additonalAssessedFile"
                        :loading="otherAssessedLoader"
                        >Add</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-timeline-item>
            </v-timeline>
            <v-row>
              <v-tooltip
                v-if="currentAssignment.status == 'Submitted' && isHost"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="12"
                    md="8"
                    v-bind="attrs"
                    v-on="on"
                    class="pl-0 ml-0 mt-3"
                  >
                    <span
                      v-if="currentAssignment.status == 'Submitted' && isHost"
                      class="font-weight-bold text-lg pt-4"
                    >
                      Attach File</span
                    >
                    <v-file-input
                      v-if="currentAssignment.status == 'Submitted' && isHost"
                      v-model="uploadAssessedFile"
                      :accept="acceptedFileFormats"
                      label="Select File"
                      chips
                    ></v-file-input>
                  </v-col>
                </template>
                <span>Upload Assignments here.</span>
              </v-tooltip>
            </v-row>
            <v-row justify="end" align="end">
              <v-btn
                class="primary"
                :loading="assessLoader"
                :disabled="!uploadAssessedFile"
                v-if="currentAssignment.status == 'Submitted' && isHost"
                @click="assessUserAssignment()"
                >Mark as Done</v-btn
              >
              <div class="pt-3" v-else>
                <v-chip
                  outlined
                  :style="
                    currentAssignment.status == 'Submitted'
                      ? currentAssignment.status == 'Assessed'
                        ? 'background-color:primary !!important'
                        : 'background-color:#00a865 !!important'
                      : 'background-color:#e5ac27 !!important'
                  "
                  :color="
                    currentAssignment.status
                      ? currentAssignment.status == 'Assessed'
                        ? 'primary'
                        : '#00a865'
                      : '#e5ac27'
                  "
                  :text-color="
                    currentAssignment.status
                      ? currentAssignment.status == 'Assessed'
                        ? 'primary'
                        : '#00a865'
                      : '#e5ac27'
                  "
                >
                  <v-icon
                    v-if="
                      currentAssignment.status == 'Submitted' ||
                      currentAssignment.status == 'Assessed'
                    "
                  >
                    check
                  </v-icon>
                  <span
                    >{{
                      currentAssignment.status
                        ? currentAssignment.status
                        : "Issued"
                    }}
                  </span>
                </v-chip>
              </div>
            </v-row>
            <v-row
              v-if="
                !isHost &&
                currentAssignment.status != 'Submitted' &&
                currentAssignment.status != 'Assessed'
              "
            >
              <v-col cols="12" md="8" class="pt-3">
                <span class="font-weight-bold text-lg pt-4"> Attach File</span>
                <v-file-input
                  v-model="uploadFile"
                  :accept="acceptedFileFormats"
                  label="Select File"
                  chips
                ></v-file-input>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-row
              justify="end"
              align="end"
              v-if="
                !isHost &&
                currentAssignment.status != 'Assessed' &&
                currentAssignment.status != 'Submitted'
              "
              ><v-btn
                :loading="submitButtonLoader"
                :disabled="!uploadFile"
                @click="submitUserAssignment()"
                class="primary"
              >
                Submit Assignment
              </v-btn></v-row
            >
          </v-col>
        </v-col>
      </v-container>
    </v-navigation-drawer>
    <v-navigation-drawer
      class="right-sidebar"
      style="position: fixed"
      :width="$vuetify.breakpoint.xs ? '100%' : '50%'"
      right
      v-model="createAssignment"
      absolute
      temporary
    >
      <v-container class="px-6">
        <v-row justify="end" align="end">
          <div class="pt-2 pr-2" style="position: absolute; right: 0; top: 0">
            <v-img
              style="cursor: pointer"
              @click="createAssignment = false"
              src="../../assets/e2medu/icons/close-24px.svg"
            ></v-img>
          </div>
        </v-row>
        <v-col class="ma-2">
          <v-row class="font-weight-bold text-lg-h5 mt-2 mb-5"
            >Create New Assignment
          </v-row>
          <v-row class="ml-2 pt-3"
            ><v-autocomplete
              class="checkScroller"
              :items="createdItems"
              clearable
              return-object
              hide-details
              :item-text="createdSessionName"
              v-model="createdSelectSession"
              label="Select Session"
              dense
              outlined
            >
            </v-autocomplete>
          </v-row>
          <!-- <v-row>
            <v-avatar color="#626262" size="40"
              ><span style="color: white">{{
                getInitials($store.state.user.Name)
              }}</span>
            </v-avatar>
            <div class="ml-3">
              <div class="font-weight-medium text-lg">Teacher Name</div>
              <div>Engilsh Teacher, EduLife</div>
            </div>
          </v-row> -->
          <v-row class="font-weight-medium text-lg ml-2 mt-6 mb-3"> </v-row>
          <v-row class="ml-2">
            <v-textarea v-model="comments" outlined label="Assignment name">
            </v-textarea>
          </v-row>
          <v-row class="ml-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-col v-bind="attrs" v-on="on">
                  <v-file-input
                    v-model="uploadFile"
                    class="mb-1"
                    :accept="acceptedFileFormats"
                    label="Select Assignment File "
                    chips
                  ></v-file-input>
                </v-col>
              </template>
              <span> Upload your assignment here</span>
            </v-tooltip>
            <v-spacer></v-spacer>
          </v-row>
          <v-row class="pa-0 ma-0" style="flex-direction: row-reverse">
            <v-btn
              :disabled="!comments || !uploadFile || !createdSelectSession"
              class="primary ml-8 mt-6"
              :loading="contentLoadedSmall"
              @click="submitFiles()"
              >Create</v-btn
            >
          </v-row>
        </v-col>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
import store from "../../store/index";
import jQuery from "jquery";
let path = require("path");
let $ = jQuery;
import apiHandler from "../../handler/edu_handler";
import helper from "../../helper/_helper";
const axios = require("axios");
var CLIENT_ID = store.state.client[0].id;
const INSTANCE_ID = process.env.VUE_APP_INSTANCE_ID;
export default {
  data() {
    return {
      otherAssessedLoader: false,
      additonalAssessedFile: null,
      assessedAdditionalAdd: false,
      additonalSubmittedFile: null,
      otherSubmittedLoader: false,
      submittedAdditionalAdd: false,
      otherCreatedLoader: false,
      contentLoadedAuto: false,
      additonalIssuedFile: null,
      createdAdditionalAdd: false,
      clientSettings: "",
      isCreate: false,
      createdSelectSession: null,
      createdItems: [],
      selectAllData: [],
      selectAllDisable: false,
      selectAll: "",
      disabledCheckBox: "disabled",
      publishedAssignments: [],
      checkBoxVal: [],
      acceptedFileFormats:
        ".pdf,.doc,.docx,.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.gif,.pgn",
      deleteButtonLoader: false,
      headers: [
        {
          text: "SESSION",
          align: "start",
          sortable: true,
          value: "sessionName",
          class: "rounded-tl-lg grey lighten-2 font-weight-bold",
        },
        {
          text: "TASK",
          value: "Name",
          width: "18%",
          sortable: true,
          class: "grey lighten-2 font-weight-bold",
        },
        {
          text: "ASSIGNED TO",
          sortable: true,
          value: "FirstName",
          class: "grey lighten-2 font-weight-bold",
        },
        {
          text: "ASSIGN DATE",
          sortable: true,
          value: "creationDate",
          class: "grey lighten-2 font-weight-bold",
        },
        {
          text: "SUBMISSION DATE",
          sortable: true,
          value: "uploadDate",
          class: "grey lighten-2 font-weight-bold",
        },
        {
          text: "STATUS",
          sortable: false,
          value: "status",
          class: "grey lighten-2 font-weight-bold",
        },
        {
          text: "",
          value: "blindCheck",
          sortable: false,
          class: "rounded-tr-lg grey lighten-2 font-weight-bold",
        },
      ],
      items: [],
      uploadAssessedFile: null,
      submitButtonLoader: false,
      selectedSession: {},
      AssignmentsList: [],
      drawer: false,
      createAssignment: false,
      isAssignmentsRoute: false,
      currentAssignment: {},
      tabClick: { tab1: true, tab2: false, tab3: false, tab4: false },
      contentLoaded: false,
      contentLoadedSmall: false,
      uploadFile: null,
      comments: null,
      ispublishDone: false,
      isHost: false,
      message: null,
      messageList: [],
      assessLoader: false,
      setInterval: null,
      intermediateAssignment: [],
    };
  },
  components: {},
  beforeDestroy() {
    clearInterval(this.setInterval);
    $("#divHeader").hide();
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDownHandler);
  },
  mounted() {
    CLIENT_ID = store.state.client[0].id;
    this.getClientConfig();
    window.addEventListener("keydown", this.keyDownHandler);
    this.eventBased = this.$store.state.eventid;
    this.getAssignments(false, "fromMounted");

    $("#topmenu").show();
    $("#leftmenu").show();
    window.scrollTo(0, 0);
    this.isAssignmentsRoute =
      this.$router?.history?.current?.name == "Assignments" ? true : false;
    this.setInterval = setInterval(() => {
      this.getAssignments(true);
    }, 30000);
    this.getSessions();
  },
  props: {
    eventBased: { default: null, type: String },
  },
  watch: {
    checkBoxVal(val) {
      if (val.length == this.selectedSession.IncludedAttendees.length) {
        this.selectAll = true;
      } else if (
        this.selectAllData.filter(
          (dat) =>
            dat.FirstName != "Created" &&
            dat.assignmentId == this.currentAssignment.assignmentId
        ).length +
          val.length ==
        this.selectedSession.IncludedAttendees.length
      ) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
    currentAssignment(val) {
      let that = this;
      this.selectAllDisable =
        that.selectAllData.filter(
          (dat) =>
            dat.FirstName != "Created" && dat.assignmentId == val.assignmentId
        ).length == this.selectedSession.IncludedAttendees.length;
    },
    uploadFile(fileName) {
      if (fileName && !this.checkFileAllowed(fileName.name)) {
        this.$nextTick(() => {
          this.uploadFile = null;
          this.showSnackbar("Wrong File format");
        });
      }
    },
    uploadAssessedFile(fileName) {
      if (fileName && !this.checkFileAllowed(fileName.name)) {
        this.$nextTick(() => {
          this.uploadAssessedFile = null;
          this.showSnackbar("Wrong File format");
        });
      }
    },
    drawer(drawerState) {
      if (!drawerState) {
        this.clearDrawers();
      }
    },
    createAssignment(drawerState) {
      if (!drawerState) {
        this.clearDrawers();
      } else {
        this.createdSelectSession = this.selectedSession;
      }
    },
    selectedSession(val) {
      if (val) {
        this.createdSelectSession = val;
        this.isHost = val.isHost;
        this.$router.replace({
          query: { session: this.selectedSession.SessionId },
        });
        if (this.isHost) this.setState("tab4");
        else this.setState("tab1");
        this.AssignmentsList = [];
        let analyticsObject = {
          eventId: this.selectedSession.eventInfo.EventId,
          action: "Select Session and get Assignments",
          actionLabel: "Select Sessions",
          actionType: "view",
          pageName: this.$route.name,
          eventName: this.selectedSession.eventInfo.EventFullName,
        };
        apiHandler.sendEventAnalytics(analyticsObject);
        if (this.isCreate) {
          this.isCreate = false;
          this.setState("tab4", "Create");
          this.getAssignments(false, "Create");
        } else this.getAssignments();
      } else {
        this.isHost = false;
        this.$router.replace({
          query: { session: "" },
        });
        this.getAssignments();
      }
    },
  },
  methods: {
    getStudentNames(attendeeList) {
      var names = [];
      attendeeList.map((attendee) => {
        names.push(attendee.FirstName);
      });
      return names.join(",");
    },
    addAdditionaCreatedFiles() {
      if (
        this.currentAssignment.otherCreatedFiles &&
        this.currentAssignment.otherCreatedFiles.length > 0
      ) {
        if (
          this.currentAssignment.otherCreatedFiles.filter(
            (x) => x.fileName == this.additonalIssuedFile.name
          ).length > 0
        ) {
          this.showSnackbar("File already exists");
          return;
        }
      }
      this.otherCreatedLoader = true;
      var bodyFormData = new FormData();
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("file", this.additonalIssuedFile);
      bodyFormData.append("type", "Created");
      apiHandler
        .addFileToAssignment(bodyFormData)
        .then((res) => {
          this.showSnackbar("File Added");
          if (!this.currentAssignment.otherCreatedFiles) {
            this.currentAssignment.otherCreatedFiles = [];
          }
          this.currentAssignment.otherCreatedFiles.push(res.data.data);
          this.otherCreatedLoader = false;
        })
        .catch((err) => {
          console.log(err);
          this.otherCreatedLoader = false;
        })
        .finally(() => {
          this.otherAssessedLoader = false;
          this.additonalAssessedFile = null;
          this.assessedAdditionalAdd = false;
          this.additonalSubmittedFile = null;
          this.otherSubmittedLoader = false;
          this.submittedAdditionalAdd = false;
          this.otherCreatedLoader = false;
          this.contentLoadedAuto = false;
          this.additonalIssuedFile = null;
          this.createdAdditionalAdd = false;
          this.otherCreatedLoader = false;
        });
    },
    addAdditionalSubmittedFiles() {
      if (
        this.currentAssignment.otherSubmittedFiles &&
        this.currentAssignment.otherSubmittedFiles.length > 0
      ) {
        if (
          this.currentAssignment.otherSubmittedFiles.filter(
            (x) => x.fileName == this.additonalSubmittedFile.name
          ).length > 0
        ) {
          this.showSnackbar("File already exists");
          return;
        }
      }
      this.otherSubmittedLoader = true;
      var bodyFormData = new FormData();
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("attendeeId", this.currentAssignment.AttendeeId);
      bodyFormData.append("file", this.additonalSubmittedFile);
      bodyFormData.append("type", "Submitted");
      apiHandler
        .addFileToAssignment(bodyFormData)
        .then((res) => {
          this.showSnackbar("File Added");
          if (!this.currentAssignment.otherSubmittedFiles) {
            this.currentAssignment.otherSubmittedFiles = [];
          }
          this.currentAssignment.otherSubmittedFiles.push(res.data.data);
          this.otherSubmittedLoader = false;
        })
        .catch(() => {
          this.otherSubmittedLoader = false;
        })
        .finally(() => {
          this.otherAssessedLoader = false;
          this.additonalAssessedFile = null;
          this.assessedAdditionalAdd = false;
          this.additonalSubmittedFile = null;
          this.otherSubmittedLoader = false;
          this.submittedAdditionalAdd = false;
          this.otherCreatedLoader = false;
          this.contentLoadedAuto = false;
          this.additonalIssuedFile = null;
          this.createdAdditionalAdd = false;
          this.otherSubmittedLoader = false;
        });
    },
    addAdditionalAssessedFiles() {
      if (
        this.currentAssignment.otherAssessedFiles &&
        this.currentAssignment.otherAssessedFiles.length > 0
      ) {
        if (
          this.currentAssignment.otherAssessedFiles.filter(
            (x) => x.fileName == this.additonalAssessedFile.name
          ).length > 0
        ) {
          this.showSnackbar("File already exists");
          return;
        }
      }
      this.otherAssessedLoader = true;
      var bodyFormData = new FormData();
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("attendeeId", this.currentAssignment.AttendeeId);
      bodyFormData.append("file", this.additonalAssessedFile);
      bodyFormData.append("type", "Assessed");
      apiHandler
        .addFileToAssignment(bodyFormData)
        .then((res) => {
          this.showSnackbar("File Added");
          if (!this.currentAssignment.otherAssessedFiles) {
            this.currentAssignment.otherAssessedFiles = [];
          }
          this.currentAssignment.otherAssessedFiles.push(res.data.data);
          this.otherAssessedLoader = false;
        })
        .catch(() => {
          this.otherAssessedLoader = false;
        })
        .finally(() => {
          this.otherAssessedLoader = false;
          this.additonalAssessedFile = null;
          this.assessedAdditionalAdd = false;
          this.additonalSubmittedFile = null;
          this.otherSubmittedLoader = false;
          this.submittedAdditionalAdd = false;
          this.otherCreatedLoader = false;
          this.contentLoadedAuto = false;
          this.additonalIssuedFile = null;
          this.createdAdditionalAdd = false;
          this.otherAssessedLoader = false;
        });
    },
    getClientConfig() {
      apiHandler.getClientConfig({ clientId: CLIENT_ID }).then((res) => {
        this.clientSettings = res;
      });
    },
    sendMessage(
      to = "",
      senderName,
      recieverName,
      subject,
      assignmentName,
      sessionName
    ) {
      let body = `Dear ${recieverName} (Student), ${senderName} ${subject} ${assignmentName} of session ${sessionName})`;
      const msg = {
        userId: [to],
        body: body,
        messagetype: "session joined",
      };
      apiHandler.sendMessage(msg);
    },
    sendMail(
      subject = "",
      to = "",
      senderName,
      recieverName,
      htmlPart,
      assignmentName = "",
      sessionName
    ) {
      var from;
      var html;
      if (location.host.includes("edulife")) {
        from = { email: "students@edulife.sg", name: "EduLife SG" };
        html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} ${htmlPart} <b>${assignmentName}</b> of session <b>${sessionName}</b>.</br></br><p>Thank you! </p></br>Team EduLife</body></ html>`;
      } else {
        from = { email: "support@mastry.io", name: "Team Mastry" };
        html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} ${htmlPart} <b>${assignmentName}</b> of session <b>${sessionName}</b>.</br></br><p>Thank you! </p></br>Team Mastry</body></ html>`;
      }
      let cc = "";
      cc = this.clientSettings.data.AdminEmailAlert;
      if (!to) {
        to = cc;
        cc = "";
      }

      let mailObject = { to, from, html, subject };
      if (cc) {
        mailObject.bcc = cc;
        mailObject.cc = "support@edulife.sg";
      }
      if(to != cc){
        apiHandler.sendMail(mailObject);
      }
    },
    createdSessionName: (item) =>
      item.Name +
      "  (" +
      item.eventInfo.EventFullName +
      ")" +
      " (" +
      item.AttendeeNames +
      ")",
    selectAllClicked() {
      this.checkBoxVal = [];
      if (this.selectAll) {
        this.selectedSession.IncludedAttendees.forEach((element) => {
          if (
            !this.publishedAssignments.some(
              (assignment) =>
                assignment.AttendeeId == element.AttendeeId &&
                assignment.assignmentId == this.currentAssignment.assignmentId
            )
          )
            this.checkBoxVal.push(element);
        });
      } else this.checkBoxVal = [];
    },
    checkBoxDisabled(attendee) {
      if (this.drawer) {
        let isDisabled = false;
        isDisabled = this.publishedAssignments.some(
          (assignment) =>
            assignment.AttendeeId == attendee.AttendeeId &&
            assignment.assignmentId == this.currentAssignment.assignmentId
        );
        return isDisabled;
      } else return false;
    },
    checkFileAllowed(val) {
      let allowedExtensions = this.acceptedFileFormats.split(",");
      return allowedExtensions.includes(path.extname(val));
    },
    keyDownHandler(event) {
      if (event.code === "Escape") {
        this.drawer = false;
        this.createAssignment = false;
      }
    },
    deleteAssignment() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Delete Assignment",
        actionLabel: "Delete",
        actionType: "delete",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      this.deleteButtonLoader = true;
      let body = {
        clientId: CLIENT_ID,
        sessionId: this.selectedSession.SessionId,
        assignmentId: this.currentAssignment.assignmentId,
      };
      apiHandler
        .deleteAssignment(body)
        .then((result) => {
          this.drawer = false;
          this.showSnackbar(result.data.msg);
          this.getAssignments();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.deleteButtonLoader = false;
        });
    },
    closeDrawer() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Close assignment details drawer",
        actionLabel: "close icon",
        actionType: "view",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
    },
    compressName(name) {
      let index = name.lastIndexOf(".") - 1;
      return name.length <= 20
        ? name
        : name.substring(0, 17) +
            "..." +
            name.substring(index - 3, index) +
            name.substring(index, name.length);
    },
    assessUserAssignment() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Assess Assignment",
        actionLabel: "Assessment Done",
        actionType: "submit",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      var bodyFormData = new FormData();
      this.assessLoader = true;
      bodyFormData.append("message", "");
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("attendeeId", this.currentAssignment.AttendeeId);
      bodyFormData.append("attendeeName", this.currentAssignment.FirstName);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("file", this.uploadAssessedFile);
      apiHandler
        .postAssessUserAssignment(bodyFormData)
        .then(() => {
          this.drawer = false;
          this.showSnackbar("Assignment Assessed");
          let subject = "(Teacher) has assessed your Assignment";
          this.sendMail(
            "Teacher has assessed your Assignment",
            this.currentAssignment.Email,
            this.$store.state.user[0].name,
            this.currentAssignment.FirstName +
              " " +
              this.currentAssignment.LastName,
            subject,
            this.currentAssignment.Name,
            this.currentAssignment.sessionName
          );
          this.sendMessage(
            this.currentAssignment.AttendeeId,
            this.$store.state.user[0].name,
            this.currentAssignment.FirstName +
              " " +
              this.currentAssignment.LastName,
            subject,
            this.currentAssignment.Name,
            this.currentAssignment.sessionName
          );
          this.getAssignments();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.assessLoader = false;
        });
    },
    downloadAttachments(url, label) {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Download Attachments",
        actionLabel: "Download Icon",
        actionType: "submit",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
          this.showSnackbar("Download Started");
        })
        .catch(console.error);
    },
    getInitials(name) {
      if (name) return helper.getInitials(name);
      else return "";
    },
    clearDrawers() {
      this.createdSelectSession = null;
      this.contentLoaded = false;
      this.uploadAssessedFile = null;
      this.contentLoadedSmall = false;
      this.uploadFile = null;
      this.submitButtonLoader = false;
      this.comments = null;
      this.uploadFile = null;
      this.ispublishDone = false;
      this.messageList = [];
      this.checkBoxVal = [];
      this.selectAll = false;
      this.allowedToPublish = [];
      this.otherAssessedLoader = false;
      this.additonalAssessedFile = null;
      this.assessedAdditionalAdd = false;
      this.additonalSubmittedFile = null;
      this.otherSubmittedLoader = false;
      this.submittedAdditionalAdd = false;
      this.otherCreatedLoader = false;
      this.contentLoadedAuto = false;
      this.additonalIssuedFile = null;
      this.createdAdditionalAdd = false;
      this.otherCreatedLoader = false;
    },
    getSessions() {
      this.contentLoaded = true;
      this.contentLoadedAuto = true;
      this.items = [];
      let body = {
        instanceId: INSTANCE_ID,
        clientId: CLIENT_ID,
        attendeeId: this.$store.state.user[0].id,
        data: {},
      };
      apiHandler
        .getAllSessionsByEvents(body)
        .then((result) => {
          result.data.data.forEach((sessionSnap) => {
            if (this.eventBased) {
              if (sessionSnap.eventId == this.eventBased) {
                if (
                  sessionSnap.IncludedAttendees &&
                  sessionSnap.IncludedAttendees.length > 0
                ) {
                  sessionSnap.AttendeeNames =
                    this.getStudentNames(sessionSnap.IncludedAttendees) !=
                    undefined
                      ? this.getStudentNames(sessionSnap.IncludedAttendees)
                      : "No Student";
                } else {
                  sessionSnap.AttendeeNames = "No Student";
                }
                this.items.push(sessionSnap);
              }
            } else {
              if (
                sessionSnap.IncludedAttendees &&
                sessionSnap.IncludedAttendees.length > 0
              ) {
                sessionSnap.AttendeeNames =
                  this.getStudentNames(sessionSnap.IncludedAttendees) !=
                  undefined
                    ? this.getStudentNames(sessionSnap.IncludedAttendees)
                    : "No Student";
              } else {
                sessionSnap.AttendeeNames = "No Student";
              }
              this.items.push(sessionSnap);
            }
            this.items.sort((a, b) =>
              a.StartDate._seconds > b.StartDate._seconds
                ? -1
                : b.StartDate._seconds > a.StartDate._seconds
                ? 1
                : 0
            );
            this.createdItems = this.items.filter((x) => x.isHost);
          });
          if (this.$route.query.session) {
            this.selectedSession = this.items.find(
              (data) => data.SessionId == this.$route.query.session
            );
          }
          //   if (!this.selectedSession && this.items[0]) {
          //     this.selectedSession = this.items[0];
          //   }
          // } else if (this.items[0]) this.selectedSession = this.items[0];
          // else {
          //   this.contentLoaded = false;
          //   this.selectedSession = {};
          // }
          this.contentLoaded = false;
          this.contentLoadedAuto = false;
        })
        .catch((err) => {
          console.log(err);
          this.contentLoaded = false;
          this.contentLoadedAuto = false;
        });
    },
    openAssignment(assignment, event) {
      let analyticsObject = {
        eventId: assignment.eventId,
        action: "Open assignment details drawer",
        actionLabel: event,
        actionType: "view",
        pageName: this.$route.name,
        eventName: assignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      this.currentAssignment = assignment;
      // console.log(assignment, "assignment");
      // this.userComment();
      this.drawer = true;
      this.ispublishDone = false;
    },
    getTimeLineDate(date) {
      return helper.getTimeLineDate(date);
    },
    getFormatted(date) {
      return helper.getFormattedAssignDate(date);
    },
    setState(tab, createState = "") {
      if (this.tabClick[tab]) return;
      else this.tabClick.tab1 = false;
      this.tabClick.tab2 = false;
      this.tabClick.tab3 = false;
      this.tabClick.tab4 = false;
      this.tabClick[tab] = true;
      this.AssignmentsList = [];
      if (createState == "Create") this.getAssignments(false, createState);
      else this.getAssignments();
    },
    getAssignments(disableReload = false, action = "") {
      if (!disableReload) {
        this.contentLoaded = true;
      }
      let body = {};
      if (this.selectedSession && this.selectedSession.SessionId) {
        if (this.selectedSession && this.selectedSession.isHost) {
          body.teacherId = this.$store.state.user[0].id;
          body.sessionId = this.selectedSession.SessionId;
          if (action == "Created") {
            body.sessionId = this.createdSelectSession.SessionId;
          }
        } else {
          body.attendeeId = this.$store.state.user[0].id;
          body.sessionId = this.selectedSession.SessionId;
          if (action == "Created") {
            body.sessionId = this.createdSelectSession.SessionId;
          }
        }
      } else if (
        !this.selectedSession
          ? !this.selectedSession
          : !this.selectedSession.SessionId
      ) {
        body.attendeeId = this.$store.state.user[0].id;
      } else if (action == "fromMounted") {
        body.attendeeId = this.$store.state.user[0].id;
      } else {
        this.contentLoaded = false;
        return;
      }
      body.clientId = CLIENT_ID;
      apiHandler
        .getAllAssignmentsDetails(body)
        .then((result) => {
          this.intermediateAssignment = [];
          if (this.isHost) {
            // this.intermediateAssignment = result.data.filter(
            //   o => o.isPublished == false
            // );

            result.data.forEach((element) => {
              if (!element.isDelete) {
                element.FirstName = "Created";
                this.intermediateAssignment.push(element);
              }
            });
            if (this.selectedSession) {
              let attendeeBody = {
                clientId: CLIENT_ID,
                teacherId: this.$store.state.user[0].id,
                getPublishedUser: true,
                sessionId: this.selectedSession.SessionId,
              };
              apiHandler
                .getAllAssignmentsDetails(attendeeBody)
                .then((result) => {
                  this.selectAllData = result.data;
                  result.data.forEach((element) => {
                    this.intermediateAssignment.push(element);
                    this.publishedAssignments.push(element);
                  });
                  if (this.tabClick.tab4) {
                    this.AssignmentsList = this.intermediateAssignment.filter(
                      (res) => res.FirstName == "Created"
                    );
                    if (action == "Create") {
                      this.currentAssignment = this.AssignmentsList.sort(
                        (a, b) =>
                          parseFloat(b.creationDate) -
                          parseFloat(a.creationDate)
                      )[0];
                      this.drawer = true;
                    }
                  }
                  if (this.tabClick.tab2)
                    this.AssignmentsList = this.intermediateAssignment.filter(
                      (res) => res.status == "Submitted"
                    );
                  if (this.tabClick.tab3) {
                    this.AssignmentsList = this.intermediateAssignment.filter(
                      (res) => res.status == "Assessed"
                    );
                  }
                  if (this.tabClick.tab1)
                    this.AssignmentsList = this.intermediateAssignment.filter(
                      (res) =>
                        res.FirstName != "Created" &&
                        res.status != "Assessed" &&
                        res.status != "Submitted"
                    );
                })
                .catch((err) => {
                  this.contentLoaded = false;
                  console.log(err);
                })
                .finally(() => {
                  // if(this.AssignmentsList.length>0){
                  this.contentLoaded = false;
                  // }
                });
            }
          } else {
            this.intermediateAssignment = result.data;
            if (this.tabClick.tab2)
              this.AssignmentsList = this.intermediateAssignment.filter(
                (res) => res.status == "Submitted"
              );
            else if (this.tabClick.tab3) {
              this.AssignmentsList = this.intermediateAssignment.filter(
                (res) => res.status == "Assessed"
              );
            } else
              this.AssignmentsList = this.intermediateAssignment.filter(
                (res) => res.status != "Assessed" && res.status != "Submitted"
              );

            if (this.eventBased) {
              this.AssignmentsList = this.AssignmentsList.filter(
                (res) => res.eventId == this.eventBased
              );
            }
            this.contentLoaded = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.contentLoaded = false;
        })
        .finally(() => {});
    },
    submitFiles() {
      this.contentLoadedSmall = true;
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Add Assignment",
        actionLabel: "Submit",
        actionType: "submit",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      var bodyFormData = new FormData();
      bodyFormData.append("name", this.comments);
      bodyFormData.append("sessionId", this.createdSelectSession.SessionId);
      bodyFormData.append("sessionName", this.createdSelectSession.Name);
      bodyFormData.append("eventId", this.createdSelectSession.eventId);
      bodyFormData.append("teacherId", this.$store.state.user[0].id);
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("file", this.uploadFile);
      apiHandler
        .createAssignment(bodyFormData)
        .then(() => {
          this.drawer = false;
          // let subject = "(Teacher) has created an Assignment";
          // this.sendMail(
          //   "Teacher has created an Assignment",
          //   undefined,
          //   this.$store.state.user[0].name,
          //   "EduLife Support",
          //   subject,
          //   this.comments,
          //   this.createdSelectSession.Name
          // );

          this.showSnackbar("Assignment Created");
          this.createAssignment = false;
          if (
            this.selectedSession.SessionId ==
            this.createdSelectSession.SessionId
          ) {
            this.setState("tab4", "Create");
            this.getAssignments(false, "Create");
          } else {
            this.isCreate = true;
            this.selectedSession = this.createdSelectSession;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.uploadFile = null;
          this.comments = null;
          this.contentLoadedSmall = false;
        });
    },
    openCreateAssignment() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Open assignment creation drawer",
        actionLabel: "Create Assignment",
        actionType: "view",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      this.createAssignment = true;
      this.ispublishDone = false;
    },
    publish() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Issue Assignment",
        actionLabel: "Issue Assignment",
        actionType: "submit",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      this.contentLoadedSmall = true;
      let body = {
        clientId: CLIENT_ID,
        sessionId: this.selectedSession.SessionId,
        assignmentId: this.currentAssignment.assignmentId,
        eventId: this.selectedSession.eventId,
      };
      if (this.checkBoxVal.length > 0) {
        body.attendeeList = this.checkBoxVal;
      }
      apiHandler
        .publishAssignment(body)
        .then(() => {
          this.ispublishDone = true;
          this.createAssignment = false;
          this.drawer = false;
          this.showSnackbar("Assignment Issued");
          let subject = "(Teacher) has issued an Assignment";
          this.checkBoxVal.forEach((attendee) => {
            this.sendMail(
              "Teacher has issued an Assignment",
              attendee.Email,
              this.$store.state.user[0].name,
              attendee.Name,
              subject,
              this.currentAssignment.Name,
              this.currentAssignment.sessionName
            );
            this.sendMessage(
              attendee.AttendeeId,
              this.$store.state.user[0].name,
              attendee.Name,
              subject,
              this.currentAssignment.Name,
              this.currentAssignment.sessionName
            );
          });
          if (this.selectAll) {
            this.setState("tab1");
          } else this.getAssignments();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.contentLoadedSmall = false;
          this.drawer - false;
        });
    },
    userComment() {
      let body = {};
      body.attendeeId = this.currentAssignment.AttendeeId;
      body.teacherId = this.currentAssignment.teacherId;
      body.clientId = CLIENT_ID;
      body.assignmentId = this.currentAssignment.assignmentId;
      apiHandler
        .getUserComment(body)
        .then((result) => {
          this.messageList = result.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.contentLoaded = false;
        });
    },
    submitUserComment() {
      var bodyFormData = new FormData();
      this.submitButtonLoader = true;
      bodyFormData.append("message", this.message);
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("teacherId", this.currentAssignment.teacherId);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("attendeeId", this.currentAssignment.AttendeeId);
      bodyFormData.append("attendeeName", this.$store.state.user[0].name);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("file", this.uploadFile);
      apiHandler
        .postUserComment(bodyFormData)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          (this.message = ""), (this.drawer = false);
          this.contentLoaded = false;
          this.submitButtonLoader = false;
        });
    },

    submitUserAssignment() {
      let analyticsObject = {
        eventId: this.currentAssignment.eventId,
        action: "Submit Assignment",
        actionLabel: "Submit Assignment",
        actionType: "submit",
        pageName: this.$route.name,
        eventName: this.currentAssignment.eventId,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      var bodyFormData = new FormData();
      this.submitButtonLoader = true;
      bodyFormData.append("message", "");
      bodyFormData.append("clientId", CLIENT_ID);
      bodyFormData.append("assignmentId", this.currentAssignment.assignmentId);
      bodyFormData.append("attendeeId", this.currentAssignment.AttendeeId);
      bodyFormData.append("attendeeName", this.currentAssignment.FirstName);
      bodyFormData.append("uploaderId", this.$store.state.user[0].id);
      bodyFormData.append("sessionId", this.currentAssignment.sessionId);
      bodyFormData.append("sessionName", this.currentAssignment.sessionName);
      bodyFormData.append("file", this.uploadFile);
      apiHandler
        .postUserAssignment(bodyFormData)
        .then(() => {
          let subject = "(Student) has submitted an Assignment";
          let currentSessionAssignment = this.items.filter(
            (obj) => obj.SessionId == this.currentAssignment.sessionId
          );
          currentSessionAssignment = currentSessionAssignment[0];
          this.sendMail(
            "Student has submitted an Assignment",
            currentSessionAssignment.MappedHosts[0].Email,
            this.$store.state.user[0].name,
            currentSessionAssignment.MappedHosts[0].Name,
            subject,
            this.currentAssignment.Name,
            this.currentAssignment.sessionName
          );
          this.sendMessage(
            currentSessionAssignment.MappedHosts[0].AttendeeId,
            this.$store.state.user[0].name,
            currentSessionAssignment.MappedHosts[0].Name,
            subject,
            this.currentAssignment.Name,
            this.currentAssignment.sessionName
          );
          this.showSnackbar("Assignment Submitted");
          this.setState("tab2");
          // this.getAssignments();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.drawer = false;
          this.contentLoaded = false;
          this.submitButtonLoader = false;
        });
    },
  },
};
</script>
<style>
.assignment.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 16px;
}
.assignment.v-data-table
  > .v-data-table__wrapper
  > table
  > .v-data-table-header
  > tr
  > th {
  font-size: 16px;
}
div::-webkit-scrollbar {
  width: 6px !important;
}
div::-webkit-scrollbar-track {
  border-radius: 10px;
  background: lightgrey;
}
div::-webkit-scrollbar-thumb {
  background: rgb(90, 86, 86);
  border-radius: 10px;
}
.no-assignment-data {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.no-assignment-data p {
    font-size: 18px;
    color: #888786;
}
</style>
<style scoped>
.v-data-table-header {
  font-size: 1rem;
}
body {
  font-size: 1rem !important;
}
.checkScroller {
  background: white;
}
.v-menu__content >>> ::-webkit-scrollbar {
  width: 12px !important; /* w idth of the entire scrollbar */
}

.v-input--selection-controls >>> .v-input__slot > .v-label,
.v-input--selection-controls >>> .v-radio > .v-label {
  margin-bottom: 0px;
}
.v-icon.outlined {
  border: 1px solid currentColor;
  border-radius: 50%;
  height: 56px;
  width: 56px;
}

.template-status.approved {
  width: 120px;
}

.template-status {
  cursor: pointer;
  justify-content: center;
  height: 30px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  min-width: 100px;
  text-align: center;
  background: #e5faf1;
  border: 2px solid #7fe5bc;
  color: #00a865;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 30px;
  position: relative;
  margin: 0;
  font-weight: 500;
  text-transform: capitalize;
}
.template-status.complete {
  background: #e8f6ff;
  border: 2px solid #8cd2ff;
  color: #1aa6ff;
  width: 128px;
}
.template-status.pending {
  background: #fff8e6;
  border: 2px solid #fadc7f;
  color: #e5ac27;
  width: 100px;
}
.bgImage {
  position: fixed;
  background-size: cover;
}
.v-application >>> .text-start {
  font-size: 15px !important;
}
.v-data-table >>> .v-data-table__wrapper >>> table >>> tbody >>> tr >>> td,
.v-data-table >>> .v-data-table__wrapper >>> table >>> tfoot >>> tr >>> td,
.v-data-table >>> .v-data-table__wrapper >>> table >>> thead >>> tr >>> td {
  font-size: 1rem !important;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 15px !important;
}
</style>
